// ***************************
// *****  Header search  *****
// ***************************

import { headerSearch } from './global';

headerSearch.setActive(false);

class HeaderSearchSystem {

    constructor(showBtn, wrapper, closeBtn, searchField) {
        this.showBtn = showBtn;
        this.wrapper = wrapper;
        this.closeBtn = closeBtn;
        this.searchField = searchField;
        this.active = false;
        // remove 'hidden' attribute
        this.wrapper.removeAttribute('hidden');
        // triggers
        this.showBtn.onclick = () => {
            if(!this.active) this.show();
        };
        this.closeBtn.onclick = () => {
            if(this.active) this.hide();
        };
        // ESC key closes search
        this.wrapper.addEventListener('keydown', (e) => {
            switch (e.key) {
                // ESCAPE jumps out a level
                case 'Escape':
                    if(this.active) {
                        e.preventDefault();
                        this.hide(true);
                    }
                    break;
            }
        });
        // loop the tabbing if search area is active
        this.closeBtn.addEventListener('keydown', (e) => {
            switch (e.key) {
                // TAB
                case 'Tab':
                    if(this.active) {
                        e.preventDefault();
                        this.searchField.focus();
                    }
                    break;
            }
        });
    }

    show() {
        this.wrapper.ontransitionend = null;
        this.wrapper.setAttribute('aria-hidden', false);
        this.showBtn.setAttribute('aria-expanded', true);
        this.active = true;
        headerSearch.setActive(true);
        window.requestAnimationFrame(() => {
            this.wrapper.classList.add('search-form--active');
            this.searchField.focus();
        });
    }

    hide(doFocus = false) {
        this.showBtn.setAttribute('aria-expanded', false);
        this.active = false;
        headerSearch.setActive(false);
        this.wrapper.classList.remove('search-form--active');
        this.wrapper.ontransitionend = (e) => {
            if(e.target == this.wrapper) this.transitionEnd(doFocus);
        };
    }

    transitionEnd(doFocus = false) {
        this.wrapper.setAttribute('aria-hidden', true);
        this.wrapper.ontransitionend = null;
        if(doFocus) this.showBtn.focus();
    }
}

const headerSearchShownBtn = document.querySelector('#header--content--search--show--btn'),
    headerSearchWrapper = document.querySelector('#header--search-wrapper'),
    headerSearchCloseBtn = document.querySelector('#header--search-close-btn'),
    headerSearchField = headerSearchWrapper !== null ? headerSearchWrapper.querySelector('input#header--search-text') : null;

if(headerSearchShownBtn != null && headerSearchWrapper != null && headerSearchCloseBtn != null && headerSearchField != null) {
    new HeaderSearchSystem(headerSearchShownBtn, headerSearchWrapper, headerSearchCloseBtn, headerSearchField);
}